// ⚠️ AUTO-GENERATED FILE - DO NOT MODIFY MANUALLY
    // This file was generated by the DTO generator script.
    // Any changes will be overwritten during the next build.

    import { SystemComponent } from '../Classes/SystemComponent';
export class Material extends SystemComponent {
  override readonly systemComponentNodeType: string = "Material";
  guid: string;
  rpn: string;
  isRPN: boolean;
  materialType: string;
  ssn: string;
  isProvidedByOthers: boolean;
  wiringType: string;
  orig: string;
  taskCategory: number;
  priceNote: string;
  isDevicePartReplaced: boolean;
  ivk: string;
  ppType: string;
  isPPA: boolean;
  mpn: string;
  manufacturerName: string;
  classification: string;
  modelNumber: string;
  saEquipmentId: string;
  existingINTHours: number;
  newINTHours: number;
  vendorNumber: string;
  vendorName: string;
  business: string;
  spCost: number | null;
  esHours: number;
  overrideDiscount: number;
  overrideCostPlus: number;
  isDiscount: boolean | null;
  sellPrice: number;
  partTypeID: number;
  declare nodeType: string;
}
